import apiClient from '../middleware/apiClient';
import { subst } from '../helpers/routes';
import {
  DSM_LABEL, COTTON_DSM_LABEL, DSM_NEW_LABEL, COTTON_DSM_NEW_LABEL,
  COTTON_V1_DSM_LABEL, COTTON_V1_DSM_NEW_LABEL,
} from '../helpers/apis';
import { callApiWithFallback } from '../helpers/apiFallback';
import { kibanaLog } from '../helpers/logger';
import cottonFlagManager from '../helpers/featureFlags/cotton';

// Fetch Label
export const FETCH_LABEL = 'FETCH_LABEL';
export const FETCH_LABEL_SUCCESS = 'FETCH_LABEL_SUCCESS';
export const FETCH_LABEL_FAILURE = 'FETCH_LABEL_FAILURE';

// Generate New Label
export const FETCH_NEW_LABEL = 'FETCH_NEW_LABEL';
export const FETCH_NEW_LABEL_SUCCESS = 'FETCH_NEW_LABEL_SUCCESS';
export const FETCH_NEW_LABEL_FAILURE = 'FETCH_NEW_LABEL_FAILURE';

export function fetchLabel(id, endpoint = DSM_LABEL) {
  return {
    type: FETCH_LABEL,
    payload: apiClient.fetch(
      subst(endpoint, { id }),
    ),
  };
}

export const fetchLabelSuccess = (label, id) => ({
  type: FETCH_LABEL_SUCCESS,
  payload: { [id]: label },
});

export const fetchLabelFailure = error => ({
  type: FETCH_LABEL_FAILURE,
  payload: error,
});

export const loadLabel = trackingId => async (dispatch, getState) => {
  if (getState().label.labelById[trackingId]) {
    return;
  }
  try {
    let response;
    const { isAptV1Enabled, dsmReturnsLabelEnabled } = cottonFlagManager;

    if (isAptV1Enabled) {
      // Use APT V1 API (100% Kotlin)
      kibanaLog('apt_v1_dsm_returns_label_api_called');
      response = await dispatch(fetchLabel(trackingId, COTTON_V1_DSM_LABEL)).payload;
    } else if (dsmReturnsLabelEnabled) {
      // Try Cotton API, fallback to Ruby API
      response = await callApiWithFallback(
        dispatch,
        () => fetchLabel(trackingId, COTTON_DSM_LABEL), // Cotton API call
        () => fetchLabel(trackingId, DSM_LABEL), // Ruby API call
        'dsm_returns_label',
      );
    } else {
      // Only call Ruby API
      response = await dispatch(fetchLabel(trackingId, DSM_LABEL)).payload;
    }
    dispatch(fetchLabelSuccess(response, trackingId));
  } catch (error) {
    dispatch(fetchLabelFailure(error));
  }
};

function fetchNewLabelInit(returnOrderId, endpoint = DSM_NEW_LABEL) {
  const url = subst(endpoint, { id: returnOrderId });
  const options = {
    method: 'PUT',
    body: JSON.stringify({
      returnMethod: 'UPS',
    }),
  };
  return {
    type: FETCH_NEW_LABEL,
    payload: apiClient.fetch(url, options),
  };
}

function fetchNewLabelSuccess(newLabel, returnId) {
  return {
    type: FETCH_NEW_LABEL_SUCCESS,
    payload: {
      returnId,
      label: newLabel,
    },
  };
}

function fetchNewLabelFailure(error) {
  return {
    type: FETCH_NEW_LABEL_FAILURE,
    payload: error,
  };
}

export const fetchNewLabel = returnOrderId => async (dispatch, getState) => {
  try {
    let response;
    const { isAptV1Enabled, dsmReturnsNewLabelEnabled } = cottonFlagManager;

    if (isAptV1Enabled) {
      kibanaLog('apt_v1_dsm_returns_new_label_api_called');
      response = await dispatch(fetchNewLabelInit(returnOrderId, COTTON_V1_DSM_NEW_LABEL)).payload;
    } else if (dsmReturnsNewLabelEnabled) {
      // Try Cotton API, fallback to Ruby API
      response = await callApiWithFallback(
        dispatch,
        () => fetchNewLabelInit(returnOrderId, COTTON_DSM_NEW_LABEL), // Cotton API call
        () => fetchNewLabelInit(returnOrderId, DSM_NEW_LABEL), // Ruby API call
        'dsm_returns_id',
      );
    } else {
      // Only call Ruby API
      response = await dispatch(fetchNewLabelInit(returnOrderId, DSM_NEW_LABEL)).payload;
    }
    dispatch(fetchNewLabelSuccess(response, returnOrderId));
  } catch (error) {
    dispatch(fetchNewLabelFailure(error));
  }
};
